import { render, staticRenderFns } from "./ProfessionalInfo.vue?vue&type=template&id=4464351c"
import script from "./ProfessionalInfo.vue?vue&type=script&lang=js"
export * from "./ProfessionalInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports